import type { NoteVisibility } from '../../../services/patientNotes';

export interface VisibilityConfig {
    label: string;
    badgeBg: string;
}

// "Internal" is the default/quiet state (most notes today) — kept low-contrast
// so it doesn't compete with the severity pill next to it. "External" is the
// notable/exceptional state (the doctor dashboard Notes tab shows only these)
// and gets a distinct accent so staff can spot it at a glance.
export const VISIBILITY: Record<NoteVisibility, VisibilityConfig> = {
    internal: {
        label: 'Internal',
        badgeBg: 'bg-gray-100 text-gray-600'
    },
    external: {
        label: 'External',
        badgeBg: 'bg-[#007E87]/10 text-[#007E87]'
    }
};
